import { SearchComponent } from '@/components/ui/search';
import { useLocation, useNavigate } from 'react-router-dom';
import { useSetHelpTopic } from '../../store/useHelpTopics';

type SearchLocationState = {
  searchQuery?: string;
};

export const SearchParticipants = ({ Close = () => {} }) => {
  const navigate = useNavigate();
  const location = useLocation();
  useSetHelpTopic('Search');

  const locationState = location.state as SearchLocationState | null;
  const searchQuery = typeof locationState?.searchQuery === 'string'
    ? locationState.searchQuery
    : undefined;

  const handleSearch = (id: string) => {
    navigate(`/participants/${id}`);
  };

  return (
    <div className="h-full overflow-hidden bg-[var(--neutral-gray-10)]">
      <div className="flex h-full flex-col px-0 py-4 sm:px-1 lg:px-1 xl:px-2">
        <div className="flex-1 min-h-0">
          <SearchComponent
            onClose={Close}
            onSearch={handleSearch}
            searchQuery={searchQuery}
          />
        </div>
      </div>
    </div>
  );
};
